// ============================================
// UTILS - Formato compartido entre las pantallas de Caja 360
// ============================================
import { formatFechaCL, getFechaHoraChile, getFechaHoyChile } from '@almacenes/core';

export const formatCurrency = (value: number | null | undefined) => `$${Math.round(value ?? 0).toLocaleString('es-CL')}`;

// Formatea lo que se va tipeando en un input de monto: quita todo lo que no
// sea dígito y aplica separador de miles, sin agregar el "$" (eso lo pone el
// input como prefijo visual).
export const formatMontoInput = (valor: string): string => {
  const soloNumeros = valor.replace(/\D/g, '');
  if (!soloNumeros) return '';
  return parseInt(soloNumeros, 10).toLocaleString('es-CL');
};

// LocalDateTime del backend ("YYYY-MM-DDTHH:mm:ss"), sin pasar por `new Date()`
// para no arrastrar la zona horaria del navegador (ver MIGRACION_FECHAS.md).
export const formatearFechaHora = (fecha: string | null | undefined): string => {
  if (!fecha) return '-';
  const [fechaParte, horaParte] = fecha.split('T');
  const hora = horaParte ? horaParte.slice(0, 5) : '';
  return `${formatFechaCL(fechaParte)}${hora ? ` ${hora}` : ''}`;
};

// Mismas claves que MethodPayment.descripcion en el backend.
const MEDIO_PAGO_LABELS: Record<string, string> = {
  EFECTIVO: 'Efectivo',
  DEBITO: 'Débito',
  CREDITO: 'Crédito',
  FIADO: 'Fiado',
  TRANSFERENCIA: 'Transferencia',
  COMPRAAQUI: 'CompraAquí',
  PEDIDOSYA: 'PedidosYa',
  MIXTO: 'Mixto',
};

export const formatMedioPago = (medioPago: string): string => MEDIO_PAGO_LABELS[medioPago] ?? medioPago;

// "YYYY-MM-DDTHH:mm" para el atributo value/min/max de <input type="datetime-local">.
const formatDatetimeLocalInput = (date: Date): string => {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  const h = String(date.getHours()).padStart(2, '0');
  const min = String(date.getMinutes()).padStart(2, '0');
  return `${y}-${m}-${d}T${h}:${min}`;
};

/** Ahora (zona Chile) y el inicio del día de hoy, listos para <input type="datetime-local">. */
export const rangoAperturaRetroactiva = (): { min: string; max: string } => ({
  min: `${getFechaHoyChile()}T00:00`,
  max: formatDatetimeLocalInput(getFechaHoraChile()),
});
